import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import Images from "../../constants/Images";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars, faTimes } from "@fortawesome/free-solid-svg-icons";

import "./Header.css";

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  const handleMobileMenuToggle = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  const closeMenu = () => {
    setMobileMenuOpen(false);
  };

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Close mobile menu on route change
  useEffect(() => {
    closeMenu();
  }, [location]);

  return (
    <header className={`header ${scrolled ? "scrolled" : ""}`}>
      <Link to="/" className="logo-container">
        <picture>
          <img className="Logo" src={Images.Logo} alt="Website Logo" />
        </picture>
      </Link>
      <nav className={`nav-links ${mobileMenuOpen ? "mobile-menu-open" : ""}`}>
        <ul className="nav-list">
          <li className="nav-item">
            <Link
              to="/"
              className={`nav-link ${
                location.pathname === "/" ? "active" : ""
              }`}
            >
              Home
            </Link>
          </li>
          <li className="nav-item">
            <Link
              to="/Bio"
              className={`nav-link ${
                location.pathname === "/Bio" ? "active" : ""
              }`}
            >
              Bio
            </Link>
          </li>
          <li className="nav-item">
            <Link
              to="/CV"
              className={`nav-link ${
                location.pathname === "/CV" ? "active" : ""
              }`}
            >
              CV
            </Link>
          </li>
          <li className="nav-item">
            <Link
              to="/Portfolio"
              className={`nav-link ${
                location.pathname === "/Portfolio" ? "active" : ""
              }`}
            >
              Projects
            </Link>
          </li>
          <li className="nav-item">
            <Link
              to="/Blogs"
              className={`nav-link ${
                location.pathname === "/Blogs" ? "active" : ""
              }`}
            >
              Blog
            </Link>
          </li>
        </ul>
      </nav>
      <button
        className="mobile-menu-icon"
        onClick={handleMobileMenuToggle}
        aria-label={mobileMenuOpen ? "Close menu" : "Open menu"}
        aria-expanded={mobileMenuOpen}
      >
        {mobileMenuOpen ? (
          <FontAwesomeIcon icon={faTimes} />
        ) : (
          <FontAwesomeIcon icon={faBars} />
        )}
      </button>
      {mobileMenuOpen && <div className="overlay" onClick={closeMenu}></div>}
    </header>
  );
};

export default Header;
